app.factory('uiGridSingleSearch', [
    'uiGridConstants', 'crudService', 'modalService', '$window', '$compile', '$timeout', '$filter', '$translate', '$templateCache', 'fileService', 'exportService', 'userPrefService', '$interpolate', '$http', 'contratService', '$rootScope',
    function (uiGridConstants, crudService, modalService, $window, $compile, $timeout, $filter, $translate, $templateCache, fileService, exportService, userPrefService, $interpolate, $http, contratService, $rootScope) {
        uiGridConstants.LOG_DEBUG_MESSAGES = false;

        // redefinition du template menu-button
        $templateCache.put('ui-grid/ui-grid-menu-button', $http.get('/templates/partials/table/menuButton.html', {cache: $templateCache}));

        /**
         * Recupere la valeur du champ en vérifiant si il y a une relation
         */
        var getColField = function (field, colField) {
            var indexOfPoint = field.indexOf('.');
            if (indexOfPoint > -1) {
                // if field has relation
                var relation = field.substr(0, indexOfPoint);	// extrait la relation
                field = field.replace((relation + '.'), '');
                colField = colField[relation];
                return getColField(field, colField);
            } else {
                if (colField == null) {
                    return null;
                }
                return colField[field];
            }
        };

        /**
         * Exporting ui-grid
         * @param  String format  csv / excel
         * @param  String extent  [description]
         * @param  Array columns colonnes à exporter
         * @return void
         */
        function exporting(format, extent, columns) {
            var grid = this.api.grid;
            grid.options.loaded = false;

            function filtered(element) {
                return element.visible;
            }

            //* mise en forme des données
            var colonnes_visibles = angular.isDefined(columns) ? columns : grid.columns.filter(filtered);   // apr défaut : seulement les colonnes affichées
            var lignes_visibles = (extent === 'visible') ? grid.api.core.getVisibleRows() : grid.api.grid.rows.filter(filtered);
            var colonnes = [];
            var lignes = [];
            var scope = [];
            var dynamic_columns_count = 0;
            var template;


            /* --------  nouvelle version de l'export -------- */
            if (
                format != 'pdf' &&
                (
                    contratService.getContratSlug() == 'planning'
                    || contratService.getContratSlug() == 'rapports'
                    || contratService.getContratSlug() == 'rapport_usid'
                    || contratService.getContratSlug() == 'cee'
                    || contratService.getContratSlug() == 'audit'
                    || contratService.getContratSlug() == 'audit_specificites'
                    || contratService.getContratSlug() == 'sps'
                    || contratService.getContratSlug() == 'controle_technique'
                ) &&
                (
                    contratService.isInFeature('planning')
                    || contratService.isInFeature('rapports')
                    || contratService.isInFeature('observations')
                    || contratService.isInFeature('interventions_rapports')
                    || contratService.isInFeature('details')

                )
            ) {
                var extras = {};
                if (format === 'excel') {
                    extras = grid.options.excelExtra;
                }

                // Pour l'instant : contrat Rapport : feature Rapport / Observation non PDF
                // Recuperation des colonnes visibles
                // var colonnes = [];
                for (var j = 0; j < colonnes_visibles.length; j++) {
                    colonnes[j] = {
                        name: $filter('capitalize')($filter('translate')(colonnes_visibles[j].displayName)),
                        field: colonnes_visibles[j].field
                    };
                }
                // Recuperation des lignes visibles
                var arrayLength = lignes_visibles.length;
                var rows = [];
                for (i = 0; i < arrayLength; i++) {
                    var rowTmp = lignes_visibles[i].entity;
                    angular.forEach(rowTmp, function (value, key) {
                        if (angular.isDate(value)) {
                            rowTmp[key] = $filter('date')(value, 'dd/MM/y');
                        }
                    });

                    rows[i] = rowTmp;
                }

                if (arrayLength < 2000) {
                    // Si moins de 2000 lignes : export direct
                    exportService.exportGrid(grid.options.orignal_name, contratService.getContratId(), format, grid.options.exportTemplate, colonnes, rows, extras).finally(function () {
                        grid.options.loaded = true;
                    });
                } else {
                    // Si plus  de 2000 lignes : export indirect
                    // Grouper les lignes par 2000 elts pour eviter un pb memoire
                    var index = 0;
                    var rowsGroup = [];
                    var chunk_size = 1500;
                    for (index; index < arrayLength; index += chunk_size) {
                        myChunk = rows.slice(index, index + chunk_size);
                        rowsGroup.push(myChunk);
                    }

                    var rowGroupLength = rowsGroup.length;
                    var countPrepared = 0;
                    var jsonFilePaths = [];
                    for (j = 0; j < rowGroupLength; j++) {
                        // Pour chaque "paquets" de lignes : création d'un fichier json
                        exportService.prepareExportGrid(grid.options.orignal_name, contratService.getContratId(), format, grid.options.exportTemplate, colonnes, rowsGroup[j], extras).then(function (response) {

                            if(typeof(response.path) !== 'undefined') {
                                countPrepared++;
                                jsonFilePaths.push(response.path);
                            }

                            if (countPrepared == rowGroupLength) {
                                // Si c'est la derniere REQ de preparation : lancer la finalisation

                                exportService.finalizeExportGrid(grid.options.orignal_name, contratService.getContratId(), format, grid.options.exportTemplate, colonnes, jsonFilePaths, extras).then(function (response) {
                                    grid.options.loaded = true;
                                }, function (error) {
                                    console.log("#error", error);
                                });

                            }
                        });
                    }

                }
            }
            /* -----! FIN nouvelle version de l'export !----- */
            else {
                var i = 0;
                for (i; i < colonnes_visibles.length; i++) {
                    colonnes[i] = $filter('translate')(colonnes_visibles[i].displayName);
                    template = colonnes_visibles[i].cellTemplate;
                    for (let j = 0; j < lignes_visibles.length; j++) {
                        if (!lignes[j]) lignes[j] = [];
                        if (!scope[j]) scope[j] = [];
                        scope[j][i] = grid.appScope.$new(true);
                        scope[j][i].COL_FIELD = getColField(colonnes_visibles[i].field, lignes_visibles[j].entity);
                        scope[j][i].row = lignes_visibles[j];
                        scope[j][i].col = colonnes_visibles[i];
                        scope[j][i].grid = grid;
                        lignes[j][i] = $compile(template)(scope[j][i]);
                    }
                }

                if (format == 'csv' && angular.isDefined(grid.options.csv_add_columns)) {
                    for (var a = 0; a < grid.options.csv_add_columns.length; a++) {
                        // Pour chaque columns à ajouter (non présentes dans l'ui-grid)
                        var column_to_add = grid.options.csv_add_columns[a];

                        colonnes[i] = column_to_add.header;
                        for (let j = 0; j < lignes_visibles.length; j++) {
                            // pour chaque lignes
                            var value = null;
                            if (angular.isDefined(lignes_visibles[j].entity[column_to_add.entity])) {
                                value = lignes_visibles[j].entity[column_to_add.entity];
                            } else if (angular.isDefined(column_to_add.default_value)) {
                                value = column_to_add.default_value;
                            }
                            lignes[j][i] = value;
                        }
                        i++;
                        dynamic_columns_count++;
                    }
                }

                $timeout(function () {
                    for (var i = 0; i < lignes.length; i++) {
                        for (var j = 0; j < (lignes[i].length - dynamic_columns_count); j++) {
                            lignes[i][j] = lignes[i][j].html();
                            scope[i][j].$destroy();
                        }
                    }

                    var extras = {};
                    if (format === 'excel') extras = grid.options.excelExtra;

                    exportService.download(format, grid.options.exportTemplate, colonnes, lignes, extras).finally(function () {
                        grid.options.loaded = true;
                    });
                });

            }
        }

        /**
         * Edition valeur d'une colonne
         */
        function updateDB(rowEntity, colDef, newValue, oldValue) {
            var dataset = this.grid.options;
            var data = {};
            if (newValue !== oldValue) {
                if (colDef.dbUpdate.modifier && this.grid.appScope[colDef.dbUpdate.modifier]) newValue = this.grid.appScope[colDef.dbUpdate.modifier](dataset, rowEntity, colDef, newValue);
                data[colDef.dbUpdate.field] = newValue;
                if ($.inArray(colDef.field, ['frequence', 'gravite', 'facteur_reducteur']) >= 0) {
                    rowEntity.cotation_risque = rowEntity.frequence * rowEntity.gravite * rowEntity.facteur_reducteur;
                }
                crudService.put(
                    colDef.dbUpdate.route + '/' + rowEntity[colDef.dbUpdate.routeId],
                    data,
                    {
                        error_code_ignore_modal: [403] /* on ignore le process par defaut de crudService lors d'un retour 403 */
                    }
                ).then(function (response) {
                    if (response === "error" || response.success === false) {
                        // Si erreur
                        newValue = oldValue;
                        if (angular.isDefined(response.message)) {
                            modalService.show(
                                'warning sign',
                                $filter('capitalize')($filter('translate')('erreur')),
                                $filter('capitalize')($filter('translate')(response.message))
                            );
                        }
                    }

                    angular.forEach(dataset.data, function (row) {
                        if (angular.isDefined(row[colDef.dbUpdate.routeId]) && (row[colDef.dbUpdate.routeId] === rowEntity[colDef.dbUpdate.routeId])) {
                            row[colDef.field] = newValue;
                        }
                    });

                    // Si les valeurs à changé sont passé par la reponse
                    if (angular.isDefined(response.fields_changed)) {
                        angular.forEach(dataset.data, function (row) {
                            if (angular.isDefined(row[colDef.dbUpdate.routeId]) && (row[colDef.dbUpdate.routeId] === rowEntity[colDef.dbUpdate.routeId])) {
                                angular.forEach(response.fields_changed, function (field_val, field_name) {
                                    row[field_name] = field_val;
                                });
                            }
                        });
                    }

                }, function (error) {
                    newValue = oldValue;
                    // Si les valeurs à changé sont passé par la reponse
                    if (angular.isDefined(error.data) && angular.isDefined(error.data.fields_changed)) {

                        angular.forEach(dataset.data, function (row) {
                            if (angular.isDefined(row[colDef.dbUpdate.routeId]) && (row[colDef.dbUpdate.routeId] === rowEntity[colDef.dbUpdate.routeId])) {
                                angular.forEach(error.data.fields_changed, function (field_val, field_name) {
                                    row[field_name] = field_val;
                                });
                            }
                        });
                    }

                    if (angular.isDefined(error.data) && angular.isDefined(error.data.message)) {
                        modalService.show(
                            'warning sign',
                            $filter('capitalize')($filter('translate')('erreur')),
                            $filter('capitalize')($filter('translate')(error.data.message))
                        );
                    }
                });
            }
        }

        /**
         * Suppression d'un fichier sur serveur avec edition du champ à null
         */
        function removeFile(col, row) {
            // @TODO : add loader
            // @TODO : ameliorer le confirm
            var c = confirm($filter('capitalize')($filter('translate')('confirm_suppr')));
            if (c == true) {

                var cellValue = this.getCellValue(row, col);
                var urlToUpdateField = col.colDef.dbUpdate.route + '/' + row.entity[col.colDef.dbUpdate.routeId];
                var urlToRemoveFile = fileService.getUrlRemove(fileService.getData(cellValue));

                // Suppression du fichier sur serveur
                crudService.upload(urlToRemoveFile).then(function (removeResponse) {
                    if (removeResponse.success) {
                        // Si suppression du fichier
                        var data = {};
                        data[col.colDef.dbUpdate.field] = null;

                        // Edition de la valeur du champ à null
                        crudService.put(urlToUpdateField, data).then(function (updateResponse) {
                            if (updateResponse.success) {
                                // All is ok
                                row.entity[col.colDef.field] = null;    // mise à jour de la valeur de l'ui-GRID à null pour ne plus afficher l'icon d'upload
                                modalService.show('trash', $filter('capitalize')($filter('translate')('suppression')), $filter('translate')('suppression_effectuee'));

                            } else {
                                // Si edition ERROR
                                if (angular.isDefined(updateResponse.message)) {
                                    modalService.show('warning sign', $filter('capitalize')($filter('translate')('erreur')), $filter('translate')(updateResponse.message));
                                }
                            }
                        }, function (updateError) {
                            // Si edition ERROR
                            if (angular.isDefined(updateError.data) && angular.isDefined(updateError.data.message)) {
                                modalService.show('warning sign', $filter('capitalize')($filter('translate')('erreur')), $filter('translate')(updateError.data.message));
                            }
                        });
                    } else {
                        if (angular.isDefined(removeResponse.message)) {
                            modalService.show('warning sign', $filter('capitalize')($filter('translate')('erreur')), $filter('translate')(removeResponse.message));
                        }
                    }
                }, function (removeError) {
                    if (angular.isDefined(removeError.data) && angular.isDefined(removeError.data.message)) {
                        modalService.show('warning sign', $filter('capitalize')($filter('translate')('erreur')), $filter('translate')(removeError.data.message));
                    }
                });
            }
        }

        function triggerUpload(event, col, row) {
            var button = angular.element(event.currentTarget);
            var input = button.next();

            $timeout(function () {
                input.off('change').on('change', function (e) {
                    upload(e, col, row);
                });
                input[0].click();
            }, 0);
        }

        function upload(e, col, row) {
            col.uploading = true;
            row.uploading = true;
            if (e.target.files.length > 0) {
                var formData = new FormData();
                formData.append('fichier', e.target.files[0]);
                var num = col.colDef.dbUpdate.field.slice(-1);
                this.grid = col.grid;
                crudService.upload('/file/' + col.colDef.uploadType + '/' + row.entity[col.colDef.dbUpdate.routeId] + '/' + num + '/upload', formData).then(function (response) {
                    updateDB(row.entity, col.colDef, response, row.entity[col.colDef.field]);
                }, function (response) {
                    if (typeof (response.data.fichier) !== 'undefined')
                        modalService.show('warning sign', $filter('capitalize')($filter('translate')('fichier_invalide')), response.data.fichier.join());//TODO TRANSLATE
                    col.error = true;
                    row.error = true;
                    $timeout(function () {
                        col.error = false;
                        row.error = false;
                    }, 3000);
                }).finally(function () {
                    col.uploading = false;
                    row.uploading = false;
                });
            } else {
                col.uploading = false;
                row.uploading = false;
            }
        }

        function prepareField(dataset, columnDefs) {
            // En attendant d'ajouter ce 2ème paramètre partout
            if (typeof (columnDefs) == 'undefined') {
                columnDefs = dataset.columnDefs;
            }

            angular.forEach(columnDefs, function (colDef) {
                if (colDef.type === 'number') {
                    angular.forEach(dataset.data, function (row) {
                        if (row[colDef.field]) {
                            if (colDef.type === 'number') row[colDef.field] = row[colDef.field] * 1;
                        }
                    });
                } else if (colDef.type === 'file') colDef.cellEditableCondition = false;
                else if (colDef.type === 'string2array') {
                    angular.forEach(dataset.data, function (row) {
                        if (row[colDef.field]) {
                            row[colDef.field] = row[colDef.field].split(',');
                        }
                    });
                }
                // Formate la date sinon erreur lors de l'édition (erreur JS + décalage d'une heure lors de l'insertion en base)
                else if (colDef.type === 'date') {

                    angular.forEach(dataset.data, function (row) {

                        if (row[colDef.field]) {

                            var date = new Date(row[colDef.field]); // Récupération de la valeur au format date

                            if (!$filter('isValidDate')(date)) {
                                // Si ce n'est pas une date valide :

                                var frenchDatePattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
                                if (frenchDatePattern.test(row[colDef.field])) {
                                    // Si Date (d/m/Y)
                                    row[colDef.field];
                                    var dateParts = row[colDef.field].split("/");
                                    date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);

                                } else if (row[colDef.field].indexOf(' ') > -1) {
                                    // Si il y a un espace (généralement, celà veut dire qu'il y a les heures avec dd/mm/yyyy hh:mm) : On enlève les heures
                                    date = row[colDef.field].slice(0, row[colDef.field].indexOf(' '));
                                    date = date.split('/'); // Découpage de la date
                                    date = new Date(new Date(date[2], date[1] - 1, date[0]));
                                }
                            }

                            if ($filter('isValidDate')(date)) {
                                row[colDef.field] = date;
                            } else {
                                // Si la date n'est toujours pas valide avec le traitement du dessus
                                //console.log("Date not valid", colDef.field, row);   // pour debug
                                row[colDef.field] = null;
                            }
                        }
                    });
                }
            });

            return dataset;
        }

        var options = {
            tooltip: function (evt, show, content) {

                if (show && ($(evt.target).find('.ui-grid-tooltip-content').length == 0)) {
                    let row = $(evt.target).parent().parent().parent().parent().next();
                    $('.ui-grid-tooltip-content').remove();
                    $(evt.target).append('<div class="ui-grid-tooltip-content">' + content + '</div>');

                    if (row.hasClass('ui-grid-row')) {
                        row.css({
                            'z-index': '-1',
                            'position': 'inherit'
                        });
                    } else {
                        $(".ui-grid-row").css({
                            'z-index': '',
                            'position': ''
                        });
                    }
                } else {
                    let row = $(evt.target).parent().parent().parent().parent().next();
                    $(evt.target).find('.ui-grid-tooltip-content').remove();

                    if (row.hasClass('ui-grid-row')) {
                        row.css({
                            'z-index': '',
                            'position': ''
                        });
                    }
                }
            },
            getDataFile: function (grid, col, row) {
                return fileService.getData(grid.getCellValue(row, col));
            },
            getUrlFile: function (data) {
                return fileService.getUrlOpen(data);
            },
            openFile: function (grid, col, row, $event) {
                $event.preventDefault();
                var data = grid.options.getDataFile(grid, col, row);
                return fileService.exists(data.type, data.id, data.num).then(function () {
                    var urlOpen = grid.options.getUrlFile(data);
                    $window.open(urlOpen, "_blank");
                    return true;
                }, function () {
                    modalService.file();
                    return false;
                });
            },
            getRowIndexByUID: function (rows, uid) {
                var index;
                angular.forEach(rows, function (row, rowIndex) {
                    if (row.uid === uid) {
                        index = rowIndex;
                    }
                    return false;
                });
                return index;
            },
            getRootScope: function () {
                return $rootScope;
            },
            loaded: false,
            gridMenuTitleFilter: $translate,
            enableGridMenu: true,
            enableFiltering: false,
            enableCellEdit: true,
            enableCellEditOnFocus: true,
            enableColumnMenus: false,
            enableCalcHeight: true,
            cellEditableCondition: function (cellScope) {
                return cellScope.grid.options.enableCellEdit;
            },
            rowHeight: 40,
            paginationPageSizes: [25, 50, 100, 200, 300, 400],
            paginationPageSize: 50,
            gridMenuCustomItems: [
                {
                    title: $filter('capitalize')($filter('translate')('filtrer_donnees')),
                    icon: 'options icon',
                    action: function () {
                        this.grid.options.enableFiltering = !this.grid.options.enableFiltering;
                        this.grid.api.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
                    },
                    shown: function () {
                        if (this.grid) {
                            return !this.grid.options.enableFiltering;
                        } else {
                            return false;
                        }
                    },
                    order: 1
                },
                {
                    title: $filter('capitalize')($filter('translate')('masquer_filtres')),
                    action: function () {
                        this.grid.options.enableFiltering = !this.grid.options.enableFiltering;
                        this.grid.api.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
                    },
                    shown: function () {
                        if (this.grid) {
                            return this.grid.options.enableFiltering;
                        } else {
                            return false;
                        }
                    },
                    order: 1
                }
            ],
            // paginationTemplate: '/templates/partials/table/pagination.html',
            headerTemplate: '/templates/partials/table/header.html',
            enableExporting: false,
            enableImporting: false,
            onRegisterApi: function (api) {
                var self = this;
                this.api = api;

                if (this.api.pagination) {
                    this.api.pagination.raise.paginationChanged = function () {
                        document.querySelectorAll('.grid' + api.grid.id + ' .ui-grid-viewport')[0].scrollTop = 0;
                    };
                }

                this.api.grid.exporting = exporting;
                this.api.grid.appScope.prepareField = prepareField;
                this.api.grid.triggerUpload = triggerUpload;
                this.api.grid.upload = upload;
                this.api.grid.updateDB = updateDB;
                this.api.grid.removeFile = removeFile;

                var updateColumns = function () {
                    var columns = {};
                    angular.forEach(api.grid.columns, function (data) {
                        columns[data.field] = {visible: data.visible, width: data.width};
                    });
                    if (Object.keys(columns).length) {
                        userPrefService.set('table', self.name, columns);
                    }
                };

                var lastHeights = {
                    grid: this.api.grid.element.height(),
                    viewport: null
                };

                api.grid.registerRowsProcessor(function (renderableRows) {
                    var gridElt = api.grid.element;

                    // set default height viewport
                    if (!lastHeights.viewport) lastHeights.viewport = jQuery('.ui-grid-viewport', gridElt).height();

                    var searchTermLength = angular.isDefined(api.grid.options.search) ? api.grid.options.search.length : 0;

                    // ---- SCROLL : Height ui-GRID for little data rows ----
                    if (api.grid.options.enableCalcHeight === true && (api.grid.rows.length > 0 || searchTermLength > 0) && (api.grid.rows.length < 20 || api.grid.element.hasClass('expand'))) {
                        $timeout(function () {
                            setRowsHeight(gridElt);
                        });
                    } else {
                        // Si plus de données OU retour de la modal ( fullscreen ) : on remet la taille par défaut
                        $timeout(function () {
                            var filterPanel = 0;
                            if ($('.ui-grid-top-panel', gridElt).length) filterPanel += $('.ui-grid-top-panel', gridElt).height();
                            if (lastHeights.viewport) jQuery('.ui-grid-viewport', gridElt).attr('style', 'height:' + (lastHeights.viewport - filterPanel - 4) + 'px !important').css('overflow-y', 'auto');
                            if (lastHeights.grid > 0) gridElt.attr('style', 'height:' + (lastHeights.grid) + 'px !important');
                        });
                    }

                    if (!self.search) {
                        return renderableRows;
                    } else {
                        let searchValue = $filter('slugify')(self.search);
                        var matcher = new RegExp(searchValue, 'i');
                        renderableRows.forEach(function (row) {
                            var match = false;

                            Object.keys(row.entity).forEach(function (field) {
                                if (row.entity[field] !== null && row.entity[field].match && $filter('slugify')(row.entity[field]).match(matcher)) match = true;
                            });
                            if (!match) row.visible = false;
                        });
                        return renderableRows;
                    }
                }, 200);

                if (this.registersRowProcessor) {
                    this.registersRowProcessor.forEach(function (row) {
                        api.grid.registerRowsProcessor(row.callback, row.priority);
                    });
                }

                if (api.edit) {
                    api.edit.on.afterCellEdit(api.grid.appScope, updateDB); // si édition active
                }

                if (api.colResizable) {
                    api.colResizable.on.columnSizeChanged(api.grid.appScope, updateColumns);
                }

                if (api.core) {
                    api.core.on.columnVisibilityChanged(api.grid.appScope, updateColumns);
                }

                if (api.colMovable) {
                    api.colMovable.on.columnPositionChanged(api.grid.appScope, updateColumns);
                }
            },

            refreshDelayedTimerId: null,
            searchLoader: false,
            refreshDelayed: function () {
                this.searchLoader = true;
                var that = this;
                if (this.refreshDelayedTimerId !== null) clearTimeout(this.refreshDelayedTimerId);
                this.refreshDelayedTimerId = setTimeout(function () {
                    that.api.grid.refresh();
                    that.searchLoader = false;
                }, 800);
            },

            refresh: function () {
                this.api.grid.refresh();
            },
            // Utiliser pour la colonne "Action"
            parseContent: function (template, row) {
                var res = $interpolate(template)(row);
                if (res === 'true') return true;
                else if (res === 'false') return false;
                return res;
            },

            run: function (methodStr, row, args) {
                return executeFunctionByName(methodStr, this.api.grid.appScope, row, args);
                // return this.api.grid.appScope[methodStr](row, args);
            },
            load: function (response) {
                if (response.columnDefs) this.columnDefs = response.columnDefs;
                if (response.data.length) {
                    if (angular.isUndefined(this.data)) { // Si data n'st pas défini (bug ?)
                        this.data = []; // Initialisation
                    }
                    this.data = this.data.concat(prepareField(response, this.columnDefs).data);
                }
                if (response.options) {
                    var self = this;
                    angular.forEach(response.options, function (value, key) {
                        self[key] = value;
                    });
                }
            },
            endLoading: function () {
                this.loaded = true;
            },
            startLoading: function () {
                this.loaded = false;
            },
            onRowsRendered: function (method) {
                this.api.core.on.rowsRendered(this.api.grid.appScope, this.api.grid.appScope[method]);
            }
        };

        /**
         * Exucute une methode formaté en string
         * @param {*} functionName
         * @param {*} context
         * @param {*} args
         */
        var executeFunctionByName = function (functionName, context, row, args) {
            var namespaces = functionName.split(".");
            var func = namespaces.pop();

            for (var i = 0; i < namespaces.length; i++) {
                context = context[namespaces[i]];
            }

            return context[func](row, args);
        };
        var setRowsHeight = function (gridElt) {
            var totalRowsHeight = 0;
            $('.ui-grid-canvas .ui-grid-row', gridElt).each(function (index, elt) {
                totalRowsHeight += $(elt).height();
            });

            var pager = 0;
            if ($('.ui-grid-pager-panel', gridElt).length) pager += $('.ui-grid-pager-panel', gridElt).height();

            var totalHeightGrid = $('.ui-grid-header', gridElt).height() + pager + totalRowsHeight + 20;
            $('.ui-grid-viewport', gridElt).attr('style', 'height:' + (totalRowsHeight + 20) + 'px !important').css('overflow-y', 'hidden');
            gridElt.attr('style', 'height:' + totalHeightGrid + 'px !important');

        };


        return {
            get: function (name) {
                var opts = angular.copy(options);
                opts.orignal_name = name;
                // uniquement pour la partie Cliente
                var contratId = contratService.getContratId();
                if (contratId) {
                    name += '_' + contratId;
                }

                opts.name = name;
                return opts;
            }
        };
    }]);
